import React, { useState, useEffect } from "react";
import './bambooSpeciesPopover.css'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// import { Container, Row, Col, Stack, Image, Modal } from 'react-bootstrap';
import { typeNumberValid, VALIDATION } from '../../common/commonValidations';
import { Button, Container, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { getBambooSpecies } from "../../common/Utils";
import { useTranslation } from "react-i18next";
import { handleNumberFieldFocus } from "../../common/commonFunction";
import { Tooltip,} from '@mui/material';

export const BambooSpeciesPopover = (props) => {
    let defaultSpecies = "Select Species";
    const { t } = useTranslation();
    const [bambooSpecies, setBambooSpecies] = useState();
    const [selectedSpecies, setSelectedSpecies] = useState('');
    const [speciesName, setSpeciesName] = useState(null);
    const [totalQuantity, setTotalQuantity] = useState('');
    
    const [bambooSpeciesDetails, setBambooSpeciesDetails] = useState({
        id: null,
        regGrowerLandDetailsId: props.landDetailsId,
        bambooSpecies: '',
        noOfClumps: '',
        clumpAge: '',
        avgClumpSize: '',
        avgPoleWeight: '',
        avgPoleHeight: '',
        avgPoleDiameter: '',
        avgPoleThinkness: '',
        committedFrequency: 'Annual',
        committedNoOfClumps: '',
        otherBambooSpecies: '',
        isActive: 1
    });
    const [errorMessage, setErrorMessage] = useState({
        speciesError: '',
        noOfClumpsError: '',
        clumpAgeError: '',
        avgClumpError: '',
        avgPoleWeightError: '',
        committedQuantityError: '',
        otherSpeciesError: ''
    });

    useEffect(() => {
        getBambooSpecies(bambooCallback);
    }, [])

    const bambooCallback = (response) => {
        setBambooSpecies(response)
        setSelectedSpecies(props.editSpecies ? props.editSpecies : '')
        setSpeciesName(props.otherSpeciesName ? props.otherSpeciesName : null);
    }

    useEffect(() => {
        if (selectedSpecies && selectedSpecies != defaultSpecies) {
            let bambooSpeciesID = ((bambooSpecies)?.filter(item => item.value === selectedSpecies))[0].id;
            const selectedSpeciesObj = (selectedSpecies !== "Others" || props?.editSpecies) ? ((props?.growerBambooSpecies)?.filter(item => item?.bambooSpecies === bambooSpeciesID && item?.otherBambooSpecies === (speciesName != null ? speciesName : item?.otherBambooSpecies))[0]) : null;
            if (selectedSpeciesObj) {
                setBambooSpeciesDetails({
                    ...bambooSpeciesDetails,
                    id: selectedSpeciesObj.id,
                    bambooSpecies: bambooSpeciesID,
                    noOfClumps: selectedSpeciesObj?.noOfClumps,
                    clumpAge: selectedSpeciesObj?.clumpAge,
                    avgClumpSize: selectedSpeciesObj?.avgClumpSize,
                    avgPoleWeight: selectedSpeciesObj?.avgPoleWeight,
                    avgPoleHeight: selectedSpeciesObj?.avgPoleHeight,
                    avgPoleDiameter: selectedSpeciesObj?.avgPoleDiameter,
                    avgPoleThinkness: selectedSpeciesObj?.avgPoleThinkness,
                    committedFrequency: selectedSpeciesObj?.committedFrequency,
                    committedNoOfClumps: selectedSpeciesObj?.committedNoOfClumps,
                    createdOn: selectedSpeciesObj?.createdOn,
                    createdBy: selectedSpeciesObj?.createdBy,
                    updatedOn: selectedSpeciesObj?.updatedOn,
                    updatedBy: selectedSpeciesObj?.updatedBy,
                    isActive: selectedSpeciesObj?.isActive,
                    otherBambooSpecies: selectedSpeciesObj?.otherBambooSpecies,
                });
                getTotalQuantity(selectedSpeciesObj.noOfClumps, selectedSpeciesObj.avgClumpSize, selectedSpeciesObj.avgPoleWeight);
            }
            if (!selectedSpeciesObj && bambooSpeciesID) {
                setBambooSpeciesDetails({
                    ...bambooSpeciesDetails,
                    bambooSpecies: bambooSpeciesID,
                    noOfClumps: '',
                    noOfClumps: '',
                    clumpAge: '',
                    avgClumpSize: '',
                    avgPoleWeight: '',
                    avgPoleHeight: '',
                    avgPoleDiameter: '',
                    avgPoleThinkness: '',
                    committedFrequency: 'Annual',
                    committedNoOfClumps: '',
                    otherBambooSpecies: ''
                });
            }
        }
    }, [selectedSpecies]);

    const getTotalQuantity = (noOfClumps, avgClumpSize, avgPoleWeight) => {
        var totalQty = 0;
        totalQty = ((avgClumpSize ? avgClumpSize:0) * (noOfClumps ? noOfClumps : 0) * (avgPoleWeight ? avgPoleWeight:0)) / 1000;
        setTotalQuantity(totalQty +' MT');
    }

    const handleChange = (e) => {
        if (e.target.name === "noOfClumps") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 6);
                setErrorMessage({ ...errorMessage, noOfClumpsError: "" })
            } else {
                setErrorMessage({
                    ...errorMessage, noOfClumpsError: "Please enter no of clumps"
                });
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
            getTotalQuantity(e.target.value, bambooSpeciesDetails.avgClumpSize, bambooSpeciesDetails.avgPoleWeight);
        }
        else if (e.target.name === "clumpAge") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 6);
                if (parseInt(slicedValue) >= 0.1 && parseInt(slicedValue) <= 99) {
                    setErrorMessage({ ...errorMessage, clumpAgeError: "" })
                }
                else {
                    setErrorMessage({
                        ...errorMessage, clumpAgeError: "Please enter age of clump between 0.1 and 99"
                    });
                }
            } else {
                setErrorMessage({
                    ...errorMessage, clumpAgeError: "Please enter age of clump"
                });
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
        }
        else if (e.target.name === "avgClumpSize") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 3);
                setErrorMessage({ ...errorMessage, avgClumpError: "" })
            } else {
                setErrorMessage({
                    ...errorMessage, avgClumpError: "Please enter average clump size"
                });
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
            getTotalQuantity(bambooSpeciesDetails.noOfClumps, slicedValue, bambooSpeciesDetails.avgPoleWeight);
        }
        else if (e.target.name === "avgPoleWeight") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 3);
            }
            else {
                setErrorMessage({ ...errorMessage, avgPoleWeightError: "Please enter weight of bamboo pole" })
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
            getTotalQuantity(bambooSpeciesDetails.noOfClumps, bambooSpeciesDetails.avgClumpSize, slicedValue);
        }
        else if (e.target.name === "avgPoleHeight") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 2);
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
        }
        else if (e.target.name === "avgPoleDiameter") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 3);
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
        }
        else if (e.target.name === "avgPoleThinkness") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 3);
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
        }
        else if (e.target.name === "committedNoOfClumps") {
            if ((e.target.value).length > 0) {
                var slicedValue = e.target.value.slice(0, 5);
            }
            else {
                setErrorMessage({ ...errorMessage, committedQuantityError: "Please enter committed quantity" })
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: slicedValue });
        }
        else if (e.target.name === "otherBambooSpecies") {
            var limit = 50;
            if ((e.target.value).length > 0) {
                setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, limit)) });
                setErrorMessage({ ...errorMessage, otherSpeciesError: "" })
            } else {
                setErrorMessage({
                    ...errorMessage, otherSpeciesError: "Please enter species name"
                });
            }
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, limit)) });
        }
        else {
            setBambooSpeciesDetails({ ...bambooSpeciesDetails, [e.target.name]: e.target.value })
        }
    };
    const validate = () => {
        if (!selectedSpecies) {
            setErrorMessage({ ...errorMessage, speciesError: "Please select species" })
            return false;
        }
        else if (!bambooSpeciesDetails?.noOfClumps) {
            setErrorMessage({ ...errorMessage, noOfClumpsError: "Please enter no of clumps" })
            return false;
        }
        else if (!bambooSpeciesDetails?.clumpAge) {
            setErrorMessage({ ...errorMessage, clumpAgeError: "Please enter age of clump" })
            return false;
        }
        else if (parseFloat(bambooSpeciesDetails?.clumpAge) < 0.1 || parseFloat(bambooSpeciesDetails?.clumpAge) > 99) {
            setErrorMessage({
                ...errorMessage, clumpAgeError: "Please enter age of clump between 0.1 and 99"
            });
            return false;
        }
        else if (!bambooSpeciesDetails?.avgClumpSize) {
            setErrorMessage({ ...errorMessage, avgClumpError: "Please enter average clump size" })
            return false;
        }
        else if (!bambooSpeciesDetails?.avgPoleWeight) {
            setErrorMessage({ ...errorMessage, avgPoleWeightError: "Please enter weight of bamboo pole" })
            return false;
        }
        else if (!bambooSpeciesDetails?.committedNoOfClumps) {
            setErrorMessage({ ...errorMessage, committedQuantityError: "Please enter committed quantity" })
            return false;
        }
        else if (selectedSpecies === "Others" && !bambooSpeciesDetails?.otherBambooSpecies) {
            setErrorMessage({ ...errorMessage, otherSpeciesError: "Please enter species name" })
            return false;
        }
        return true;
    }
    const onSpeciesSelect = (e) => {
        setSelectedSpecies(e.target.value);
        setErrorMessage({ ...errorMessage, speciesError: "" })
    };
    const submit = () => {
        if (validate()) {
            props.handleLogModalClose();
            props.bambooSpeciesSubmitCallbackFunction(bambooSpeciesDetails, props.handleLogModalClose);
        }
    }


    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h5" gutterBottom>
                    {t('reg.bambooSpecies')}
                </Typography>
                <InputLabel sx={{ color: 'green' }}>Total Quantity: {totalQuantity}</InputLabel>
                <Grid container spacing={2} direction="row" mt={1}>
                    <Grid item xs={12} lg={6}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <FormControl fullWidth required error={errorMessage.speciesError}>
                                    <InputLabel>{t('reg.speciesType')}</InputLabel>
                                    <Select
                                        label="Species Type"
                                        value={selectedSpecies}
                                        disabled={props.editSpecies ? true : props.isDisabled}
                                        onChange={(e) => onSpeciesSelect(e)}>
                                        {/* <MenuItem value="">Select Species</MenuItem> */}
                                        {bambooSpecies?.map((item, index) => {
                                            return (
                                                <MenuItem key={item} value={item?.value}>{item?.value}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.speciesError}</FormHelperText>
                                </FormControl>
                            </Grid>
                            {selectedSpecies === "Others" &&
                                <Grid item xs={12}>
                                    <TextField fullWidth
                                        required
                                        error={errorMessage.otherSpeciesError}
                                        helperText={errorMessage.otherSpeciesError}
                                        type="text"
                                        name="otherBambooSpecies"
                                        disabled={props.editSpecies ? true : props.isDisabled}
                                        value={bambooSpeciesDetails.otherBambooSpecies}
                                        label={t('reg.speciesName')} onChange={(e) => handleChange(e)} />
                                </Grid>}
                            <Grid item xs={12}>
                                <TextField fullWidth
                                    required
                                    error={errorMessage.noOfClumpsError}
                                    helperText={errorMessage.noOfClumpsError}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    name="noOfClumps"
                                    disabled={props.isDisabled}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    value={bambooSpeciesDetails.noOfClumps}
                                    label={t('reg.noOfClumps')}
                                    onChange={(e) => handleChange(e)} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth
                                    required
                                    error={errorMessage.clumpAgeError}
                                    helperText={errorMessage.clumpAgeError}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    name="clumpAge"
                                    disabled={props.isDisabled}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    value={bambooSpeciesDetails.clumpAge}
                                    label={t('reg.ageOfClump')}
                                    onChange={(e) => handleChange(e)} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth
                                    required
                                    error={errorMessage.avgClumpError}
                                    helperText={errorMessage.avgClumpError}
                                    disabled={props.isDisabled}
                                    InputProps={{
                                        maxLength: 3
                                    }}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    name="avgClumpSize"
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    value={bambooSpeciesDetails.avgClumpSize}
                                    label={t('reg.avgClumpSize')}
                                    onChange={(e) => handleChange(e)} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth
                                    required
                                    error={errorMessage.avgPoleWeightError}
                                    helperText={errorMessage.avgPoleWeightError}
                                    disabled={props.isDisabled}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    name="avgPoleWeight"
                                    InputProps={{
                                        maxLength: 3
                                    }}
                                    value={bambooSpeciesDetails.avgPoleWeight}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    label={t('reg.avgWeightOfBambooPole')}
                                    onChange={(e) => handleChange(e)} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <TextField fullWidth
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    name="avgPoleHeight"
                                    InputProps={{
                                        maxLength: 2
                                    }}
                                    disabled={props.isDisabled}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    value={bambooSpeciesDetails.avgPoleHeight}
                                    label={t('reg.avgHeightOfBambooPole')} onChange={(e) => handleChange(e)} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    InputProps={{
                                        maxLength: 3
                                    }}
                                    disabled={props.isDisabled}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    name="avgPoleDiameter"
                                    value={bambooSpeciesDetails.avgPoleDiameter}
                                    label={t('reg.bambooPoleDiameter')}
                                    onChange={(e) => handleChange(e)} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    InputProps={{
                                        maxLength: 3
                                    }}
                                    disabled={props.isDisabled}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    name="avgPoleThinkness"
                                    value={bambooSpeciesDetails.avgPoleThinkness}
                                    label={t('reg.bambooPoleWallThickness')}
                                    onChange={(e) => handleChange(e)} />
                            </Grid>
                            <Grid item xs={12}>
                            <Tooltip  title="Quantity of bamboo committed to supply to ABEPL" arrow>
                                <TextField fullWidth
                                    required
                                    error={errorMessage.committedQuantityError}
                                    helperText={errorMessage.committedQuantityError}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    name="committedNoOfClumps"
                                    disabled={props.isDisabled}
                                    InputProps={{
                                        endAdornment: (
                                            <Select
                                                variant="standard"
                                                size="small"
                                                name="committedFrequency"
                                                disabled={props.isDisabled}
                                                value={bambooSpeciesDetails.committedFrequency}
                                                onChange={(e) => handleChange(e)} >
                                                <MenuItem value="Annual">{t('reg.annual')}</MenuItem>
                                                <MenuItem value="Monthly">{t('reg.monthly')}</MenuItem>
                                            </Select>
                                        ),
                                        maxLength: 5
                                    }}
                                    onKeyDown={(evt) => typeNumberValid(evt)}
                                    value={bambooSpeciesDetails.committedNoOfClumps}
                                    label={t('reg.committedQuantity')}
                                    onChange={(e) => handleChange(e)} />
                                    </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Container>
            <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                <Button sx={{ minWidth: 100 }} variant="outlined" onClick={props.handleLogModalClose}>{t('reg.cancel')}
                </Button>
                <Button disabled={props.isDisabled} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => submit()}>{props.editSpecies ? t('reg.update') : t('reg.add')}</Button>
            </Box>
        </>
    );
};
